export const BRAND_NAME = 'Krishna365';
export const BRAND_DOMAIN = 'krishna365.com';
export const PROVIDER = 'Betfair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'krna79.com';